import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

import { PuSubscribable } from '@app/utils/pu-subscribe';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

@Component({
  selector: 'app-do-not-upload-to-pms-menu',
  templateUrl: './do-not-upload-to-pms-menu.component.html',
  styleUrls: ['./do-not-upload-to-pms-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoNotUploadToPmsMenuComponent extends PuSubscribable implements OnInit {
  @Input() set uploadToPms(_uploadToPms: boolean) {
    const value = _uploadToPms ?? true;
    if (value === this.form?.get('uploadToPms')?.value) {
      return;
    }
    this.form.get('uploadToPms')?.setValue(value);
  }
  @Output() submitForm = new EventEmitter<boolean>();

  form: FormGroup = new FormGroup({
    uploadToPms: new FormControl(true),
  });
  readonly options: IRadioButtonOption<boolean>[] = [
    {
      value: false,
      label: 'OFF',
    },
    {
      value: true,
      label: 'ON',
    },
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form
      .get('uploadToPms')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(value => this.submitForm.emit(value))
      .untilDestroyed(this);
  }
}
